import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  container: {
    paddingTop: theme.spacing(8.5),
    fontFamily: "'Outfit', sans-serif",
    position: "relative",
    color: theme.palette.primary.main,
  },
  popover: {
    paddingTop: 0,
  },
  modal: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    top: "auto",
    maxHeight: "80vh",
    overflowY: "auto",
    backgroundColor: "white",
    borderTopLeftRadius: theme.spacing(3),
    borderTopRightRadius: theme.spacing(3),
    boxShadow: "0 -4px 20px rgba(0, 0, 0, 0.15)",
    zIndex: 1300,
    paddingTop: 0,
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 1299,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),
    paddingTop: theme.spacing(5),
    paddingBottom: 350,
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
  },
  promptContainer: {
    width: "100%",
    padding: theme.spacing(2),
    border: "1px solid #d2d2d7",
    borderRadius: theme.spacing(3),
    backgroundColor: theme.palette.background.default,
    transition: "border-color 0.2s",

    "&:focus-within": {
      borderColor: theme.palette.secondary.main,
    },
  },
  imagesRow: {
    display: "flex",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1.5),
    flexWrap: "wrap",
  },
  imageWrapper: {
    position: "relative",
    borderRadius: theme.spacing(1.5),
    overflow: "visible",
  },
  uploadedImage: {
    width: 80,
    height: 80,
    objectFit: "cover",
    borderRadius: theme.spacing(1.5),
    border: `1px solid ${theme.palette.divider}`,
  },
  imageRemoveButton: {
    position: "absolute",
    top: -8,
    right: -8,
    width: 24,
    height: 24,
    borderRadius: "50%",
    backgroundColor: theme.palette.error.main,
    color: "white",
    border: `2px solid ${theme.palette.background.paper}`,
    display: "grid",
    placeItems: "center",
    cursor: "pointer",
    transition: "all 0.2s",
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",

    "&:hover": {
      backgroundColor: theme.palette.error.dark,
      transform: "scale(1.1)",
    },
  },
  promptInput: {
    width: "100%",
    padding: 0,
    border: "none",
    fontSize: "1rem",
    outline: "none",
    backgroundColor: "transparent",
    resize: "none",

    "&::placeholder": {
      color: theme.palette.text.secondary,
    },
  },
  closeButtonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    position: "sticky",
    top: 0,
    left: 0,
    padding: theme.spacing(2),
    backgroundColor: "transparent",
    zIndex: 1,
  },
  closeButton: {
    cursor: "pointer",

    "&:hover": {
      opacity: 0.8,
    },
  },
  headerWrapper: {
    width: "100%",
  },
  stickyCompactSummary: {
    position: "fixed",
    top: 50,
    left: 0,
    right: 0,
    zIndex: 1000,
    backgroundColor: "white",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    animation: "slideDown 0.3s ease-out",
    "@keyframes slideDown": {
      from: {
        transform: "translateY(-100%)",
      },
      to: {
        transform: "translateY(0)",
      },
    },
  },
}));
